"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
class FileName extends base_models_1.Serializable {
}
exports.default = FileName;
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsDefined)(),
    (0, base_models_1.Docs)({
        example: 'emobility*accountId$uniqueId$brand.jpg',
        description: 'Document ID of the file to review or delete',
    }),
    tslib_1.__metadata("design:type", String)
], FileName.prototype, "documentId", void 0);
